import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none"
}
const _hoisted_2 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none"
}
const _hoisted_3 = {
  key: 2,
  id: "process",
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "50",
  viewBox: "0 0 50 50",
  fill: "none",
  style: {"display":"block"}
}
const _hoisted_4 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none"
}
const _hoisted_5 = {
  key: 4,
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none"
}
const _hoisted_6 = {
  key: 5,
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.name === $setup.STATUS_SUCCESS && $props.type === $setup.DEFAULT)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("path", {
            d: "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
            fill: "#27AE60"
          }, null, -1),
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M34.1943 15.5488C35.0065 16.1775 35.2432 17.3803 34.7268 18.3073C30.7202 25.4994 27.0745 30.2848 24.9201 32.8462C23.7614 34.224 21.8982 34.4007 20.5843 33.1986C18.7085 31.4824 15.9516 28.5687 13.3133 24.3247C12.8161 23.5249 12.9238 22.4585 13.5434 21.7669L15.132 19.9938C15.8716 19.1684 17.0873 19.1457 17.8332 19.9644C20.46 22.8478 22.4973 25.4624 22.4973 25.4624C22.4973 25.4624 25.491 20.6058 30.1398 14.7174C30.7823 13.9035 31.8908 13.7659 32.6946 14.388L34.1943 15.5488Z",
            fill: "white"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    ($props.name === $setup.STATUS_ERROR && $props.type === $setup.DEFAULT)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("path", {
            d: "M28 51.3334C32.2396 51.3334 35.1057 51.0275 36.4737 50.8382C37.0869 50.7533 37.6635 50.5145 38.1571 50.141C39.2583 49.3075 41.5012 47.4972 44.4991 44.4992C47.4971 41.5012 49.3074 39.2584 50.1408 38.1572C50.5144 37.6636 50.7532 37.087 50.838 36.4738C51.0274 35.1059 51.3333 32.2399 51.3333 28.0001C51.3333 23.7603 51.0274 20.8943 50.838 19.5263C50.7532 18.9131 50.5144 18.3366 50.1408 17.843C49.3074 16.7417 47.4971 14.4988 44.4991 11.5009C41.5012 8.50298 39.2583 6.69268 38.1571 5.85922C37.6635 5.48563 37.0869 5.24683 36.4737 5.16195C35.1057 4.97261 32.2396 4.66675 28 4.66675C23.7602 4.66675 20.8943 4.97261 19.5262 5.16195C18.913 5.24683 18.3365 5.48563 17.8428 5.85921C16.7416 6.69265 14.4988 8.50295 11.5008 11.5009C8.50282 14.4989 6.69253 16.7417 5.8591 17.843C5.48552 18.3366 5.24672 18.9131 5.16184 19.5262C4.9725 20.8943 4.66663 23.7603 4.66663 28.0001C4.66663 32.2399 4.97249 35.1059 5.16184 36.4738C5.24672 37.087 5.48552 37.6636 5.8591 38.1572C6.69253 39.2584 8.50281 41.5012 11.5008 44.4992C14.4987 47.4972 16.7416 49.3075 17.8428 50.141C18.3365 50.5145 18.913 50.7533 19.5262 50.8382C20.8941 51.0275 23.7602 51.3334 28 51.3334Z",
            fill: "#EF564C"
          }, null, -1),
          _createElementVNode("path", {
            d: "M25.4092 12.012C24.0076 12.412 23.3825 13.8497 23.4781 15.3042C23.6985 18.6579 24.1436 24.8453 24.6235 28.167C24.7653 29.1497 25.3352 30.0077 26.3109 30.1917C26.7501 30.2745 27.3063 30.3334 28 30.3334C28.6937 30.3334 29.25 30.2745 29.6891 30.1917C30.6648 30.0077 31.2347 29.1497 31.3766 28.167C31.8564 24.8453 32.3015 18.6579 32.5219 15.3042C32.6176 13.8497 31.9925 12.412 30.5908 12.012C29.8998 11.8147 29.0361 11.6667 28 11.6667C26.9639 11.6667 26.1002 11.8147 25.4092 12.012Z",
            fill: "white"
          }, null, -1),
          _createElementVNode("path", {
            d: "M28 43.1666C30.5773 43.1666 32.6667 41.0772 32.6667 38.4999C32.6667 35.9226 30.5773 33.8333 28 33.8333C25.4228 33.8333 23.3334 35.9226 23.3334 38.4999C23.3334 41.0772 25.4228 43.1666 28 43.1666Z",
            fill: "white"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    ($props.name === $setup.STATUS_PROCESS)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M25 5C13.9543 5 5 13.9543 5 25C5 36.0457 13.9543 45 25 45C36.0457 45 45 36.0457 45 25C45 13.9543 36.0457 5 25 5ZM1 25C1 11.7452 11.7452 1 25 1C38.2548 1 49 11.7452 49 25C49 38.2548 38.2548 49 25 49C11.7452 49 1 38.2548 1 25Z",
            fill: "#A6CFFF",
            stroke: "#A6CFFF",
            "stroke-width": "2"
          }, null, -1),
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M45 25C45 13.9543 36.0457 5 25 5V1C38.2548 1 49 11.7452 49 25H45Z",
            fill: "#6059F4",
            stroke: "#6059F4",
            "stroke-width": "2"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    ($props.name === $setup.STATUS_ERROR && $props.type === $setup.TELE2)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("path", {
            d: "M24 44C12.954 44 4 35.046 4 24C4 12.954 12.954 4 24 4C35.046 4 44 12.954 44 24C44 35.046 35.046 44 24 44ZM24 40C28.2435 40 32.3131 38.3143 35.3137 35.3137C38.3143 32.3131 40 28.2435 40 24C40 19.7565 38.3143 15.6869 35.3137 12.6863C32.3131 9.68571 28.2435 8 24 8C19.7565 8 15.6869 9.68571 12.6863 12.6863C9.68571 15.6869 8 19.7565 8 24C8 28.2435 9.68571 32.3131 12.6863 35.3137C15.6869 38.3143 19.7565 40 24 40V40ZM22 30H26V34H22V30ZM22 14H26V26H22V14Z",
            fill: "#B30D14"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    ($props.name === $setup.STATUS_SUCCESS && ($props.type === $setup.TELE2 || $props.type === $setup.ALTEL))
      ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("path", {
            d: "M24 44C12.954 44 4 35.046 4 24C4 12.954 12.954 4 24 4C35.046 4 44 12.954 44 24C44 35.046 35.046 44 24 44ZM24 40C28.2435 40 32.3131 38.3143 35.3137 35.3137C38.3143 32.3131 40 28.2435 40 24C40 19.7565 38.3143 15.6869 35.3137 12.6863C32.3131 9.68571 28.2435 8 24 8C19.7565 8 15.6869 9.68571 12.6863 12.6863C9.68571 15.6869 8 19.7565 8 24C8 28.2435 9.68571 32.3131 12.6863 35.3137C15.6869 38.3143 19.7565 40 24 40V40ZM22.006 32L13.52 23.514L16.348 20.686L22.006 26.344L33.318 15.03L36.148 17.858L22.006 32Z",
            fill: "#75AD3F"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    ($props.name === $setup.STATUS_ERROR && $props.type === $setup.ALTEL)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("path", {
            d: "M24 43.75C13.0921 43.75 4.25 34.9079 4.25 24C4.25 13.0921 13.0921 4.25 24 4.25C34.9079 4.25 43.75 13.0921 43.75 24C43.75 34.9079 34.9079 43.75 24 43.75ZM24 40.25C28.3098 40.25 32.443 38.538 35.4905 35.4905C38.538 32.443 40.25 28.3098 40.25 24C40.25 19.6902 38.538 15.557 35.4905 12.5095C32.443 9.46205 28.3098 7.75 24 7.75C19.6902 7.75 15.557 9.46205 12.5095 12.5095C9.46205 15.557 7.75 19.6902 7.75 24C7.75 28.3098 9.46205 32.443 12.5095 35.4905C15.557 38.538 19.6902 40.25 24 40.25ZM25.75 30.25V33.75H22.25V30.25H25.75ZM25.75 14.25V25.75H22.25V14.25H25.75Z",
            fill: "#EE6F2D",
            stroke: "white",
            "stroke-width": "0.5"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true)
  ], 64))
}